module.exports = __webpack_public_path__ + "img/img8.c1957df1.png";